module.exports = __webpack_public_path__ + "img/ic_seat.20035bff.svg";